import { InfiniteData, useQueryClient, useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import useSlingApi from '@sdk/api/useSlingApi';

import {
  getAnnouncementsQueryKey,
  getAnnouncementDetailsQueryKey,
} from '@web/announcements/utils/getQueryKey';
import { useAnnouncementsQueryCache } from '@web/announcements/hooks/useAnnouncementsQueryCache';
import { mapAnnouncement } from '@web/announcements/utils/mappers';
import { Announcement } from '@web/announcements/types/Announcement';

export const useGetAnnouncementDetails = (id: ID) => {
  const { announcements } = useSlingApi();
  const queryClient = useQueryClient();
  const { updateRecipients } = useAnnouncementsQueryCache();
  const listQueryKey = getAnnouncementsQueryKey();
  const detailsQueryKey = getAnnouncementDetailsQueryKey(id);

  const result = useQuery({
    queryKey: detailsQueryKey,
    queryFn: async () => {
      const { data } = await announcements.get(id);

      return mapAnnouncement(data);
    },
    placeholderData: () => {
      const cachedData = queryClient.getQueryData<InfiniteData<Announcement[]>>(listQueryKey);
      if (!cachedData) return;

      return cachedData.pages.flat().find((item) => item.id === id);
    },
  });

  useEffect(() => {
    if (result.data) {
      updateRecipients(id, result.data.recipients);
    }
  }, [result.data, id, updateRecipients]);

  return result;
};
